import React from 'react'
import { intlShape } from '../../../util/reactIntl';
import { array, bool } from 'prop-types';
import css from '../ListingPage.module.css'
import { H4,ListingCard, NamedLink, Ratings } from '../../../components';
import { propTypes } from '../../../util/types';
import IconCard from '../../../components/SavedCardDetails/IconCard/IconCard';
import { Swiper, SwiperSlide } from 'swiper/react';
import ListCardComponent from '../ListingCard';

export default function AuthorListings(props) {
    const {
        intl,
        authorListings,
        authorListingsInProgress,
        authorListingsError,
        author, isVerified, rating,
        currentUserCurrency,
        exchangeRates,
        history,
        routes,
        queryID
    } = props;


    // No need to render the component if author don't have the listings
    // progress and error props have been take in case future use.
    if (!authorListings || !authorListings.length || !author || !author?.id) {
        return null
    };

    const profile = author?.attributes?.profile;
    const city = profile?.publicData?.city;
    const displayName = profile.displayName;

    const authorListingsTitle = intl.formatMessage({ id: 'AuthorListings.title' }, {displayName});
    const viewMore = intl.formatMessage({ id: 'AuthorListings.viewMore' });

    const searchString = !!city && !!displayName
        ? `?name=${displayName}&city=${city}`
        : !!displayName
            ? `?name=${displayName}`
            : !!city
                ? `?city=${city}`
                : ''

    const linkProps = { name: 'ProfilePage', params: { id: author.id.uuid }, to: { search: searchString } };
 
    return (
        <div className={css.similarItemSection}>
            <H4 className={css.itemTitle}>{authorListingsTitle} </H4>
            <p className={css.itemSubTitle}>
                 Discover more rentals from this trusted owner.
            </p>
            {/* <Ratings className={css.rating} rating={rating}/> */}
            <div className={css.similarItemCards}>
                {/* {authorListings.length > 7 ? <NamedLink {...linkProps} className={css.viewMore}>
                    {viewMore}
                </NamedLink> : null} */}
                   <Swiper
                spaceBetween={24}
                slidesPerView={3}
                navigation
                style={{ padding: '8px 0' }}
                breakpoints={{
                    0: { slidesPerView: 1.1, spaceBetween: 12 },
                    600: { slidesPerView: 2 },
                    1024: { slidesPerView: 3 },
                }}
            >
                    {authorListings.map(l => (<SwiperSlide  key={l.id.uuid}>
                        <ListCardComponent
                                rental={{
                                    objectID: l.id.uuid,
                                    title: l.attributes.title,
                                    price: l.attributes.price,
                                    user: {
                                        displayName: l.author.attributes.profile.displayName,
                                        publicData: l.author.attributes.profile.publicData,
                                    },
                                    publicData: l.attributes.publicData,
                                    distance: l.attributes.distance,
                                    _geoloc: l.attributes.geolocation,
                            }}
                            currentUserCurrency={currentUserCurrency}
                            exchangeRates={exchangeRates}
                            onClick={() => { }}
                            history={history}
                            routes={routes}
                            queryID={queryID}
                            additional={l.additional}
                            isVerified={isVerified}
                            author={author}
                        />
                        </SwiperSlide>))}
                </Swiper>
            </div>
        </div>
    )
};

AuthorListings.propTypes = {
    intl: intlShape.isRequired,
    authorListings: array.isRequired,
    authorListingsInProgress: bool,
    authorListingsError: propTypes.error,
    author: propTypes.user.isRequired
};
